export const DATABASE_CASE_CREATION = 'src/Analyst/Cases/Database/action/Database_Case_Creation'
export const DATABASE_CASE_CREATION_SUCCESS = 'src/Analyst/Cases/Database/action/Database_Case_Creation_Success'
export const DATABASE_CASE_CREATION_FAILURE = 'src/Analyst/Cases/Database/action/Database_Case_Creation_Failure'
export const databaseCaseCreation = (data) => {
    return {
        type: DATABASE_CASE_CREATION,
        data
    }
}
export const databaseCaseCreationSuccess = (data) => {
    return {
        type: DATABASE_CASE_CREATION_SUCCESS,
        data
    }
}
export const databaseCaseCreationFailure = (data) => {
    return {
        type: DATABASE_CASE_CREATION_FAILURE,
        data
    }
}